/**
 * Multi-Step Checkout Main JavaScript
 *
 * Initializes and wires together all checkout modules.
 *
 * @package Hafo\Checkout
 * @version 1.0.0
 */

// Wait for DOM to be ready before importing modules
function initCheckoutModules() {
    const checkoutContainer = document.querySelector('.hafo-multistep-checkout');
    if (!checkoutContainer) {
        return;
    }

    Promise.all([
        import ('./modules/step-manager.js'),
        import ('./modules/cart-handler.js'),
        import ('./modules/coupon-handler.js'),
        import ('./modules/order-review-handler.js')
    ]).then((modules) => {

        const StepManager = modules[0].default;
        const CartHandler = modules[1].default;
        const CouponHandler = modules[2].default;
        const OrderReviewHandler = modules[3].default;

        const stepManager = new StepManager();
        const cartHandler = new CartHandler();
        const couponHandler = new CouponHandler();
        const orderReviewHandler = new OrderReviewHandler();

        const checkoutForm = document.querySelector('.woocommerce-checkout');
        if (checkoutForm) {
            checkoutForm.addEventListener('submit', (e) => {
                const currentStep = stepManager.getCurrentStep();
                if (currentStep !== 3) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        window.hafoCheckoutInstance = {
            stepManager,
            cartHandler,
            couponHandler,
            orderReviewHandler,
        };
    }).catch((error) => {
        console.error('Hafo Checkout: ❌ Failed to load modules', error);
        console.error('Hafo Checkout: Error details', {
            message: error.message,
            stack: error.stack,
            fileName: error.fileName,
            lineNumber: error.lineNumber
        });
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCheckoutModules);
} else {
    initCheckoutModules();
}
